<template>
    <div class="col-12 p-2 mx-auto mt-2">
        <div class="col-6 p-0 d-flex align-items-center mt-5">
            <h2 class="m-0"> 
                <strong> 
                    {{ title }}
                </strong>
            </h2>
        </div>
        <p class="pt-4 pb-2" v-if="subTitle">
          {{ subTitle }}
        </p>
        <h3 class="mt-3"
            style="color:#78909C;"
            v-if="showLocation">
          📍{{ currentUserLocation }}
        </h3>
    </div>
</template>

<script>
    export default {
        name: 'HeaderV2',
        props: {
            title: String
            , subTitle: {
              type: String
              , required: false
              , default: () => null
          }
          , showLocation: {
              type: Boolean
            , required: false
            , default: () => true
          }
        }
    }
</script>